<template>
  <div class="home-wrap">
    <div class="home-bg"></div>

    <div class="slide-scroll">
      <div class="slide-inner">
        <h1 class="main-title">Протестируйте навыки инвестора/трейдера</h1>
        <p class="sub-title">Вы последовательно окажетесь в трёх сценариях. Каждый кейс требует анализа, выбора стратегии и оценки последствий - как в реальной торговле.</p>
        <div class="promo-box">
          <p class="promo-label">Три кейса</p>
          <div class="cards-row">
            <div class="card-outer">
              <div class="card-bg-img"></div>
              <div class="info-card card-bg-green">
                <div class="card-title-block">
                  <div class="icon-wrapper">
                    <img :src="chartIcon" class="card-icon card-icon-round" alt="">
                  </div>
                  <div class="info-card-title info-card-title-bg-green">Играем на прибыль</div>
                </div>
                <div class="info-card-desc">Предыдущие сделки были успешными. Решите, как действовать дальше.</div>
              </div>
            </div>
            <div class="card-outer">
              <div class="card-bg-img"></div>
              <div class="info-card card-bg-blue">
                <div class="card-title-block">
                  <div class="icon-wrapper">
                    <img :src="zeroIcon" class="card-icon" alt="">
                  </div>
                  <div class="info-card-title info-card-title-bg-blue">Играем с нуля</div>
                </div>
                <div class="info-card-desc">Прибыли и убытков пока нет. Выберите стратегию.</div>
              </div>
            </div>
            <div class="card-outer">
              <div class="card-bg-img"></div>
              <div class="info-card card-bg-gray">
                <div class="card-title-block">
                  <div class="icon-wrapper">
                    <img :src="chartDownIcon" class="card-icon" alt="">
                  </div>
                  <div class="info-card-title info-card-title-bg-gray">Играем с убытков</div>
                </div>
                <div class="info-card-desc">Предыдущие сделки ушли в минус. Решите, как исправить ситуацию.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="slide-footer">
      <button class="nav-btn" @click="$router.push('/mode')">Назад</button>
      <button class="nav-btn" @click="next">Далее</button>
    </div>
  </div>
</template>

<script>
import chartIcon     from '@/assets/icons/chart.png'
import zeroIcon      from '@/assets/icons/zero.png'
import chartDownIcon from '@/assets/icons/chart-down.png'

export default {
  name: 'HomeView',
  data() { return { chartIcon, zeroIcon, chartDownIcon } },
  methods: {
    next() { this.$router.push('/play') }
  }
}
</script>

<style scoped>
.home-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.home-bg {
  position: absolute;
  inset: 0;
  background: url('../assets/icons/bg2.png') center / cover no-repeat;
  z-index: 0;
  pointer-events: none;
}

.slide-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: hidden;
  overflow-x: hidden;
  position: relative;
  z-index: 1;
}

.slide-inner {
  padding: var(--space-24) var(--page-x) var(--space-12);
}

.main-title {
  font-size: var(--fs-48);
  font-weight: 700;
  color: var(--color-navy);
  line-height: 1.3;
  margin: var(--space-60) 0 var(--space-10);
}

.sub-title {
  font-size: var(--fs-25);
  color: var(--color-muted);
  margin: 0 0 var(--space-48);
}

.promo-box {
  background: var(--surface-glass);
  border-radius: var(--space-24);
  padding: var(--space-14) var(--space-24) var(--space-32);
  box-shadow: var(--shadow-soft-large);
}

.promo-label {
  font-size: var(--fs-25);
  font-weight: 700;
  color: var(--color-navy);
  margin: 0 0 var(--space-24);
}

.cards-row {
  display: flex;
  gap: var(--space-10);
}

.info-card {
  flex: 1;
  border-radius: var(--space-8);
  padding: var(--space-14) var(--space-12);
  color: var(--color-white);
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
}

.card-outer {
  flex: 1;
  position: relative;
  border-radius: var(--space-8);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.card-bg-img {
  position: absolute;
  inset: 0;
  background: url('../assets/icons/candles.png') center / cover no-repeat;
  pointer-events: none;
  z-index: 1;
  opacity: 0.15;
}

.card-outer .info-card {
  flex: 1;
  position: relative;
  border-radius: 0;
}

.card-bg-green { background: var(--color-card-green-alpha); }
.card-bg-blue  { background: var(--color-card-blue-alpha);  }
.card-bg-gray  { background: var(--color-card-gray-alpha);  }

.card-title-block {
  display: flex;
  min-width: 0;
}

.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--color-white-border);
  border-radius: var(--space-10);
  background: transparent;
  padding: var(--space-3) var(--space-4);
}

.card-icon {
  width: var(--space-32);
  height: var(--space-32);
}

.card-icon-round { border-radius: var(--space-6); }

.info-card-title {
  height: var(--space-34);
  font-size: var(--fs-20);
  font-weight: 700;
  color: var(--color-white);
  line-height: 1.2;
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  padding-left: var(--space-8);
  align-self: center;
}
.info-card-title-bg-blue {
  background: var(--gradient-card-title-blue);
}
.info-card-title-bg-gray {
  background: var(--gradient-card-title-gray);
}
.info-card-title-bg-green {
  background: var(--gradient-card-title-green);
}

.info-card-desc {
  font-size: var(--fs-18);
  color: var(--color-white-text-soft);
  line-height: 1.3;
  padding: var(--space-12) var(--space-12) var(--space-12) var(--space-54);
}

/* Footer */
.slide-footer {
  flex-shrink: 0;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-8) var(--page-x) var(--space-24);
}


.nav-btn {
  background: var(--color-button);
  color: var(--color-navy);
  border: none;
  padding: 0 var(--space-28);
  height: var(--space-54);
  min-width: var(--space-200);
  font-size: var(--fs-20);
  font-weight: 600;
  border-radius: var(--space-6);
  cursor: pointer;
  box-shadow: var(--shadow-soft-large);
}
.nav-btn:hover { background: var(--color-button-hover); }

.nav-btn-placeholder {
  min-width: var(--space-120);
  height: var(--space-54);
}

@media (max-width: 700px) {
  .home-wrap { overflow-y: auto; }
  .slide-scroll { overflow-y: auto; }
  .slide-inner { padding: 22px 20px 14px; }
  .main-title { font-size: 25px; margin: 22px 0 12px; line-height: 1.18; overflow-wrap: break-word; }
  .sub-title { font-size: 16px; margin-bottom: 22px; }
  .promo-box { border-radius: 14px; padding: 14px; }
  .promo-label { font-size: 18px; margin-bottom: 12px; }
  .cards-row { flex-direction: column; gap: 10px; }
  .info-card { padding: 12px; }
  .info-card-title { min-height: 34px; height: auto; width: auto; flex: 1; font-size: 18px; }
  .info-card-desc { font-size: 14px; padding: 8px 4px 2px; overflow-wrap: break-word; }
  .slide-footer { padding: 8px 16px 14px; gap: 10px; }
  .nav-btn { min-width: 82px; height: 42px; padding: 0 10px; font-size: 15px; }
  .nav-btn-placeholder { min-width: 82px; height: 42px; }
}
</style>
